import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../assets/purelifespan300-1.png';
import Licence from '../assets/nz_licence.png';

// 네비게이션 메뉴 목록 (필요하다면 이 부분도 별도 파일로 분리 가능)
const menuItems = [
  { name: 'HOME', path: '/' },
  { name: 'ABOUT US', path: '/about' },
  { name: 'HUMAN', path: '/human' },
  { name: 'ANIMAL', path: '/animal' },
  { name: 'MEDIA', path: '/media' },
];

function Header({ onMenuClick }) {
  return (
    <header
      className="sticky top-0 z-50 bg-white p-4 shadow-md
      flex flex-col sm:flex-row           /* 모바일: 세로 정렬, 데스크톱: 가로 정렬 */
      items-center sm:items-start        /* 모바일: 가로 중앙 정렬, 데스크톱: 상단 정렬 */
      sm:justify-between                 /* 데스크톱: 로고와 네비게이션을 양 끝으로 분리 */
      w-full                             /* 헤더 너비는 항상 전체 */"
    >
      <div className="flex items-center gap-4 mb-3 sm:mb-0">
        {/* 로고 이미지 사용 */}
        <img src={Logo} alt="회사 로고" className="max-h-28 object-contain" />
      </div>
      <div
        className="flex flex-col items-center           /* 모바일: 작은 이미지와 네비게이션을 세로로 쌓고 가로 중앙 정렬 */
          sm:items-end                         /* 데스크톱: 오른쪽 정렬 */
          w-full sm:w-auto                     /* 모바일: 전체 너비, 데스크톱: 내용에 맞게 */
          mt-4 sm:mt-0                         /* 모바일: 상단 마진, 데스크톱: 마진 없음 */
          sm:self-end                          /* 데스크톱: 헤더의 끝으로 정렬 */
          sm:mb-[10px] sm:mr-[40px]            /* 데스크톱: 특정 마진 */
      "
      >
        {/* 작은 이미지 */}
        <img
          src={Licence}
          alt="Licence"
          className="w-auto h-auto max-w-[160px] object-cover mb-3  sm:self-end" // mb-3으로 아래 여백 추가
        />

        {/* 네비게이션 */}
        <nav className="w-full sm:w-auto">
          <div
            className="flex flex-wrap gap-4 sm:gap-6
            justify-center sm:justify-end   /* 모바일: 버튼 가로 중앙 정렬, 데스크톱: 버튼 오른쪽 정렬 */"
          >
            {menuItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className="font-semibold text-base hover:text-blue-600 transition-colors"
              >
                {item.name}
              </Link>
            ))}
          </div>
        </nav>
      </div>
    </header>
  );
}

export default Header; // Header 컴포넌트를 내보냅니다.
